// extracted by mini-css-extract-plugin
export var content = "ExperimentalPhoneNumber-module--content--1e590";
export var icon = "ExperimentalPhoneNumber-module--icon--21345";
export var phoneDisclaimer = "ExperimentalPhoneNumber-module--phone-disclaimer--1c7ed";
export var phoneNumber = "ExperimentalPhoneNumber-module--phone-number--46840";
export var phoneNumberContainer = "ExperimentalPhoneNumber-module--phone-number-container--ce769";
export var withDisclaimer = "ExperimentalPhoneNumber-module--with-disclaimer--9e0d5";